import { render, staticRenderFns } from "./Correlaction.vue?vue&type=template&id=1d62b36a&"
import script from "./Correlaction.vue?vue&type=script&lang=js&"
export * from "./Correlaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports